import DashBoardCard from './DashBoardCard'

export default DashBoardCard
